<template>
  <BoxCard>
    <template #header>About clinicians</template>
    <template #content>
      <div v-for="(clinician, index) in this.$page.props.course.clinicians" :key="clinician.id">
        <div class="gap-3 inline-flex justify-center items-center">
          <div class="flex">
            <ViceAvatar
              :image="clinician.profile_photo_url"
              :name="clinician.name"
              class="w-12 h-12"
            />
          </div>
          <div class="flex flex-col">
            <p class="text-lg font-semibold text-gray-900">
              {{ clinician.name }}
            </p>
            <p class="text-xs font-medium text-gray-900" v-if="clinician.details">
              {{ clinician.title }}
            </p>
            <p class="text-xs font-medium text-gray-900" v-if="clinician.details">
              {{ clinician.details.position }}
            </p>
          </div>
        </div>
        <div class="mt-2" v-if="clinician.details?.intro_about">
          <h3 class="text-sm leading-6 font-medium text-gray-900">Areas of expertise</h3>
          <div class="my-3 text-xs text-gray-800">
            {{ clinician.details?.intro_about }}
          </div>
          <div class="my-3 text-xs text-gray-800" :class="readMore ? 'block' : 'hidden'">
            {{ clinician.details?.read_more_about }}
          </div>
          <span
            v-if="clinician.details?.read_more_about"
            @click="toggleReadMore"
            class="text-vice-teal-600 text-xs"
          >
            {{ readMore ? 'Less' : 'Read more' }}
          </span>
        </div>
        <div v-if="this.$page.props.course.clinicians.length !== index + 1" class="relative my-5">
          <hr class="w-full text-gray-200" />
        </div>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { ref } from 'vue';
import BoxCard from '@/Components/Cards/BoxCard.vue';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';

export default {
  name: 'AboutCourseClinician',
  setup() {
    const readMore = ref(false);
    return {
      readMore,
    };
  },
  components: {
    BoxCard,
    ViceAvatar,
  },
  methods: {
    toggleReadMore() {
      this.readMore = !this.readMore;
    },
  },
};
</script>

<style scoped></style>
